import React from "react";
import styles from "./OpportunityDetails.module.scss";
import BaseTable, { AutoResizer, Column } from "react-base-table";
import customTableComponents from "./OpportunityDetailsTableComponent";
import { Spinner } from "@blueprintjs/core";

function OpportunityDetailsLists({
  applicants,
  influencers,
  onLeftColumnResize,
  onRightColumnResize,
  leftColumns,
  rightColumns,
  leftColumnWidths,
  rightColumnWidths,
  isLoading,
  getColumnWidth,
  openApplicantDetails,
  isReadOnly
}) {
  return (
    <div className={styles.listsWrapper}>
      <div className={styles.leftTable}>
        <AutoResizer>
          {({ width, height }) => {
            return (
              <BaseTable
                fixed
                rowClassName={styles.leftTableRow}
                data={applicants || []}
                width={width}
                height={height}
                components={customTableComponents(isReadOnly)}
                rowEventHandlers={{
                  onClick: ({ rowData }) =>
                    openApplicantDetails({
                      id: rowData.id,
                      type: rowData.type
                    })
                }}
                emptyRenderer={
                  isLoading ? (
                    <div className={styles.empty}>
                      <Spinner />
                    </div>
                  ) : (
                    <div className={styles.empty}>No Applicants Found</div>
                  )
                }
                onColumnResizeEnd={onLeftColumnResize}
                className={styles.mainTable}
              >
                {leftColumns.map((column, index) => (
                  <Column
                    {...column}
                    width={getColumnWidth({
                      columnWidths: leftColumnWidths,
                      index,
                      width
                    })}
                  />
                ))}
              </BaseTable>
            );
          }}
        </AutoResizer>
      </div>
      <div className={styles.rightTable}>
        <AutoResizer>
          {({ width, height }) => {
            return (
              <BaseTable
                fixed
                rowClassName={styles.leftTableRow}
                data={influencers || []}
                width={width}
                height={height}
                components={customTableComponents(isReadOnly)}
                rowEventHandlers={{
                  onClick: ({ rowData }) =>
                    openApplicantDetails({
                      id: rowData.id,
                      type: rowData.type
                    })
                }}
                emptyRenderer={
                  isLoading ? (
                    <div className={styles.empty}>
                      <Spinner />
                    </div>
                  ) : (
                    <div className={styles.empty}>No Influencers Found</div>
                  )
                }
                onColumnResizeEnd={onRightColumnResize}
                className={styles.mainTable}
              >
                {rightColumns.map((column, index) => (
                  <Column
                    {...column}
                    width={getColumnWidth({
                      columnWidths: rightColumnWidths,
                      index,
                      width
                    })}
                  />
                ))}
              </BaseTable>
            );
          }}
        </AutoResizer>
      </div>
    </div>
  );
}

export default OpportunityDetailsLists;
